import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import {breakpoint} from "./breakpoints";

gsap.registerPlugin(ScrollTrigger);



gsap.utils.toArray('.js-parallax-header').forEach((item, index) => {
    let scroll_height = $(item).outerHeight() / 2

  gsap.fromTo(
    item,
    { y: 0 },
    {
      y: scroll_height,
      ease: 'none',
      scrollTrigger: {
        trigger: item,
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    }
  );
});